import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ng-business-arrow-divider',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './arrow-divider.component.html',
  styleUrls: ['./arrow-divider.component.scss'],
})
export class ArrowDividerComponent {
  @Input() imageSrc = 'assets/images/3-orange-arrows-down.svg';
  @Input() alt = 'Arrow divider';
}
